/**
 * Created by gustavolemoss on 9/6/19.
 */
import axios from 'axios';

const API_KEY_PAGARME = 'ak_test_8VShIWqrXoOPGNpEi3DnGTum9WHAqz';

class ApiPagarmeCustomer {
	
    get(email) {
        delete axios.defaults.headers.common['Authorization'];
        return axios.get(`https://api.pagar.me/1/search?api_key=${API_KEY_PAGARME}&type=customer&query={%22query%22:%20{%22filtered%22:%20{%22query%22:{%22match_phrase%22:{%22email%22:{%22query%22:%22${email}%22}}}}}}`);
    }
	
    getCardsPagarMe(email) {
      const pagarme = require('pagarme');
	    
      pagarme.client.connect({ api_key: API_KEY_PAGARME })
	    
	      .then(client => {
	      	
	        this.get(email)
		        
		        .then((response) => {
			        
		          const hits = response.data.hits.hits;
		          const customer_id = response.data ? hits.length ? hits[0]._id : 0 : 0;
		          
		          client.cards.find({ customer_id: customer_id })
			          
			          .then((cards) => {
		          	
		          	  console.log(cards);
		          	
		              return cards;
		              
	            }).catch((error) => {
		            
		              console.log(error);
		              return [1];
			          
	            });
	        }).catch((error) => {
		         
	          console.log(error);
	          return [2];
		         
	        });
	    }).catch((error) => {
	      
	        console.log(error);
	        return [3];
	      
	    });
	    
		
    };
    
	
	
}

export default new ApiPagarmeCustomer();


// WEBPACK FOOTER //
// ./src/utils/api.pagarme.customer.js